const themeLightNotificationInfo = '#2762EC';

export { themeLightNotificationInfo };
